import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onSendFeedback} from '../actions/AccountActions';
import FeedbackForExtraPops from '../components/FeedbackForExtraPops';

@connect(null, {onSendFeedback})
export default class FeedbackForExtraPopsContainer extends Component {
    static propTypes = {
        onSendFeedback: PropTypes.func,
        onSuccess: PropTypes.func,
        limit: PropTypes.number,
    };

    handleSubmit = (data) => {
        const {limit, onSuccess} = this.props;
        const feedbackType = 'nextFreePopsBatch';
        const successNotification = `Thank you for your feedback. You should receive your next ${limit} free pops shortly`;
        this.props.onSendFeedback({...data, feedbackType}, successNotification, onSuccess);
    };

    render() {
        return (
            <div className="card" style={{minHeight: 600}}>
                <FeedbackForExtraPops onSubmit={this.handleSubmit} limit={this.props.limit}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/FeedbackForExtraPopsContainer.js